import { Link } from "react-router-dom";
import { Instagram, Twitter, Linkedin } from "lucide-react";

// Phase N — 4-column footer.
// Column 1 (brand): logo, tagline, socials.
// Column 2 (Company): About, Methodology, Team, Impact, Press.
// Column 3 (Product): Florida Transfer System, Pricing, Tools, Resources.
// Column 4 (Partnership): ILC partner page.
// Column 5 (Legal): Privacy, Terms, Refund, Accessibility.
const COLS = [
  { title: "Company", testId: "footer-col-company", links: [
    { to: "/about",        label: "About" },
    { to: "/methodology",  label: "Methodology" },
    { to: "/team",         label: "Team" },
    { to: "/impact",       label: "Impact" },
    { to: "/press",        label: "Press" },
    { to: "/company",      label: "One-pager" },
  ]},
  { title: "Product", testId: "footer-col-product", links: [
    { to: "/build-my-plan",           label: "Build My Plan" },
    { to: "/mishap-corrector",        label: "Mishap Corrector" },
    { to: "/transfer-map",            label: "Transfer Map" },
    { to: "/transfer-audit",          label: "Transfer Audit" },
    { to: "/tools",                   label: "Tools" },
    { to: "/florida-transfer-system", label: "Florida Transfer System" },
    { to: "/pricing",                 label: "Pricing" },
    { to: "/contact",                 label: "Contact" },
  ]},
  { title: "Partnership", testId: "footer-col-partnership", links: [
    { to: "/partners/ivy-league-consulting", label: "Ivy League Consulting" },
    { to: "/resources",                      label: "Guides" },
    { to: "/blog",                           label: "Blog" },
  ]},
  { title: "Legal", testId: "footer-col-legal", links: [
    { to: "/privacy",       label: "Privacy" },
    { to: "/terms",         label: "Terms" },
    { to: "/refund-policy", label: "Refund Policy" },
    { to: "/accessibility", label: "Accessibility" },
  ]},
];

export default function Footer() {
  return (
    <footer className="bg-ink text-bone-dim mt-24 border-t border-ivy/40" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-10">
        <div className="col-span-2 sm:col-span-3 lg:col-span-2">
          <Link to="/" className="text-base uppercase tracking-[0.2em] font-semibold text-bone block">
            Beyond Valencia
          </Link>
          <p className="mt-4 text-sm text-stone-soft max-w-xs leading-relaxed">
            The national platform for transfer strategy, educational mobility, and second-chance admissions.
          </p>
          <div className="mt-6 flex gap-3 text-stone-soft">
            <a href="#" aria-label="Instagram" className="hover:text-brass-soft transition-colors"><Instagram className="h-4 w-4" /></a>
            <a href="#" aria-label="X" className="hover:text-brass-soft transition-colors"><Twitter className="h-4 w-4" /></a>
            <a href="#" aria-label="LinkedIn" className="hover:text-brass-soft transition-colors"><Linkedin className="h-4 w-4" /></a>
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title} data-testid={col.testId}>
            <div className="text-[10px] uppercase tracking-[0.24em] text-brass mb-4 font-medium">{col.title}</div>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.to + l.label}>
                  <Link to={l.to} className="text-sm text-stone-soft hover:text-bone transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-ivy/30">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-stone flex flex-col sm:flex-row justify-between gap-2">
          {/* TODO: confirm exact legal entity name */}
          <span>© 2026 Beyond Valencia LLC. All rights reserved.</span>
          <span className="uppercase tracking-[0.18em] text-[10px]">Orlando · Florida-anchored · National in reach</span>
        </div>
      </div>
      <div className="border-t border-ivy/30 bg-ink">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 text-[11px] text-stone-soft text-center" data-testid="footer-attribution">
          Beyond Valencia is powered by Ivy League Consulting.
        </div>
      </div>
    </footer>
  );
}
